import React from 'react';
import FormFieldList from '@/forms/components/FormFieldList';
import formFieldType, { formFieldText } from '@/forms/helper';
import fieldComponents from '../helper';
import Selectors from '../hooks/selectors';
import Events from '../../hooks/events';
import Fetch from '../../templates/hooks/fetch';

const TaskFieldList = ({ children, direction, section }) => {
  const {
    canEdit, fields, task, template,
  } = Selectors.useTaskFieldList({ section });
  const updateProperties = Events.useUpdateTaskFormProperties();
  Fetch.useFetchTaskTemplateForTask({
    category: 'open',
    code: task.formKey,
    taskCode: task.code,
    templateReadStatus: template.readStatus,
  }, task.readStatus);

  return (
    <FormFieldList
      canEdit={canEdit}
      className="aridhia-task-field-list"
      component={(f) => fieldComponents[formFieldType(f)]}
      direction={direction}
      fields={fields}
      isEditing={task.isEditing}
      onChange={({ properties, names }) => updateProperties({
        properties, fields: names, entity: section, template,
      })}
      saveErrors={task.saveErrors}
      saveStatus={task.saveStatus}
      section={section}
      text={(f) => formFieldText(task, f, 'fields.')}
    >
      {children}
    </FormFieldList>
  );
};

export default TaskFieldList;
